module.exports = __webpack_public_path__ + "static/media/rte.fddc0643.20a2a239.svg";